import { Injectable, OnChanges, OnInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';

@Injectable()
export class ThemeSpinnerService implements OnChanges, OnInit, OnDestroy {

	public constructor() {    }

	/* --------------------- */

	public ngOnChanges() {    }

	public ngOnInit() {    }

	public ngOnDestroy() {    }

	/* --------------------- */

	/** 
	 * Show spinner
	 * 
	 * @param target 
	 */
	public show( spinnerTarget: string = 'body', overlayVisible: boolean = true, blockerTarget: string = 'body' ): void {

		if ( spinnerTarget != 'no-loader' ) {

			// get spinner target
			var targetSpinner = $( spinnerTarget );
			var targetHeight = targetSpinner.outerHeight();
			var targetWidth = targetSpinner.outerWidth();
			var targetSize = ( ( targetHeight <= targetWidth ) ? targetHeight : targetWidth ) * 25 / 100;
			var targetMargin = ( targetSize <= 70 ) ? - ( targetSize / 2 ) + 'px' : '-35px';

			// set spinner options
			var spinnerClass = ( spinnerTarget !== 'body' ) ? 'absolute' : 'fixed';
			var spinnerSize = targetSize + 'px';

			// set overlay options
			var overlayClass = overlayVisible ? 'visible' : 'transparent';

			// define spinner
			var spinner = '<div class="preloader ' + overlayClass + ' ' + spinnerClass + '"><div class="spinner" style="width: ' + spinnerSize + '; height: ' + spinnerSize + '; margin-top: ' + targetMargin + '; margin-left: ' + targetMargin + '"><div class="double-bounce1"></div><div class="double-bounce2"></div></div></div>';

			// manage targetSpinner
			if ( $.inArray( targetSpinner.css( 'position' ), ['relative', 'absolute', 'fixed'] ) === -1 ) {

				targetSpinner.css( 'position', 'relative' );

			}

			// add spinner to target
			targetSpinner.append( spinner );

		}

		// get blocker target
		var targetBlocker = $( blockerTarget );

		// add blocker to target
		targetBlocker.append( '<div class="blocker"></div>' );

	}

	/**
	 * Hide spinner
	 * 
	 * @param target 
	 * @param delay 
	 */
	public hide( spinnerTarget: string = 'body', blockerTarget: string = 'body', delay: number = 1000 ): void {

		if ( spinnerTarget != 'no-loader' ) {

			// set delay and hide spinner and blocker
			setTimeout(() => {

				$( spinnerTarget + ' > .preloader' ).remove();

			}, delay );

		}

		// set delay and hide spinner and blocker
		setTimeout(() => {

			$( blockerTarget + ' > .blocker' ).remove();

		}, delay );

	}

}



// WEBPACK FOOTER //
// ./src/app/theme/services/themeSpinner.service.ts